// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__fIpvW","obliqueLineWrap":"membershipbadge_obliqueLineWrap__P8MV4","obliqueLine":"membershipbadge_obliqueLine__1mAOJ"};